import { colors } from '@mui/material';
import React from 'react';
import { useDrumKitContext } from './DrumKitContext';
import { DrumName } from './DrumName';
function usePadProps(note) {
    const context = useDrumKitContext();
    return {
        className: context.className(note),
        onClick: () => context.onPadClick?.(note)
    };
}
export function Drum(props) {
    const { id, cx, cy, r, note, namePosition } = props;
    return React.createElement("g", { className: `pad ${id}` },
        React.createElement("circle", { ...{ id, cx, cy, r }, ...usePadProps(note) }),
        React.createElement(DrumName, { ...{ cx, cy, r, position: namePosition }, note: note }));
}
export function Cymbal(props) {
    const { id, cx, cy, r, note, namePosition } = props;
    return React.createElement("g", { className: `pad ${id}` },
        React.createElement("circle", { ...{ id, cx, cy, r }, ...usePadProps(note) }),
        React.createElement(DrumName, { ...{ cx, cy, r, position: namePosition }, note: note }));
}
export function Pedal(props) {
    const { id, x, y, r, width, height, note, namePosition } = props;
    return React.createElement("g", { className: `pedal ${id}` },
        React.createElement("rect", { ...{ id, x, y, rx: r, ry: r, width, height }, ...usePadProps(note) }),
        React.createElement(DrumName, { cx: x + width / 2, cy: y + height / 2, r: width / 2, position: namePosition, note: note }));
}
export function RideBell(props) {
    const { id, cx, cy, r, note } = props;
    return React.createElement("g", { className: `pad ${id}` },
        React.createElement("circle", { ...{ id, cx, cy, r }, stroke: colors.blueGrey[400], strokeWidth: 2, ...usePadProps(note) }),
        React.createElement(DrumName, { ...{ cx, cy, r, position: 'center' }, note: note }));
}
export function HiHat(props) {
    const { id, cx, cy, r, note } = props;
    const path = `M${cx},${cy} h${-r} a${r},${r} 0 1,0 ${r},${-r} v${r} Z`;
    return React.createElement("g", { className: `pad ${id}` },
        React.createElement("path", { id: id, d: path, ...usePadProps(note) }),
        React.createElement(DrumName, { ...{ cx, cy: cy + r / 2, r, position: 'left' }, note: note }));
}
export function OpenHiHat(props) {
    const { id, cx, cy, r, note } = props;
    const shift = 9;
    const path = `M${cx - shift},${cy - shift} h${-r} a${r},${r} 0 0,1 ${r},${-r} v${r} Z`;
    return React.createElement("g", { className: `pad ${id}` },
        React.createElement("path", { id: id, d: path, ...usePadProps(note) }),
        React.createElement(DrumName, { ...{ cx, cy: cy - r / 2, r, position: 'left' }, note: note }));
}
export function DrumStick({ tip, sticking }) {
    const head1 = 'c1.52,0,2.87,1.7,2.87,3.16 l0.13,3.55 c0,0.92,-0.53,1.99,-1.3,2.64 ';
    const right = 'l0.5,4.05 l1.55,34.14 l0.15,27.77 c0,15.91,0.1,79.56,0.1,95.48';
    const bottom = 'c0,2.71,-3.2,3.21,-4,3.21 c-0.8,0,-4,-0.491,-4,-3.21';
    const left = 'c0,-15.91,0.1,-79.5654,0.1,-95.48 l0.15,-27.77 l1.55,-34.14 l0.51,-4.05';
    const head2 = 'c-0.78,-0.65,-1.31,-1.72,-1.31,-2.64l0.13,-3.54c0,-1.47,1.35,-3.17,2.87,-3.17';
    const path = `M${tip.x},${tip.y} ${head1} ${right}  ${bottom} ${left} ${head2} z`;
    return React.createElement("path", { className: `stick ${sticking}`, d: path });
}
//# sourceMappingURL=Elements.js.map